import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import client from "../../../../shared/api-client";
import login from "../../../../shared/login";
import logout from "../../../../shared/logout";
import { Link } from "react-router-dom";

class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      error_message: "",
    };

    this.showPassword = this.showPassword.bind(this);
  }

  componentDidMount() {
    logout();
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  }

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val });
  };

  submit = () => {
    client(`admin/login`, {
      method: "POST",
      body: { email: this.state.email, password: this.state.password },
    }).then(
      (response) => {
        if (
          typeof response._user_message_type !== undefined &&
          response._user_message_type === "error"
        ) {
          this.setState({ error_message: response._user_message });
        } else {
          login(response.auth_adminid, response.admin_token);
          window.location.assign("/dashboard");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  render() {
    return (
      <div className="form">
        {this.state.error_message !== "" ? (
          <div className="errorMessage">{this.state.error_message}</div>
        ) : (
          ""
        )}

        <div className="form__form-group">
          <span className="form__form-group-label">Username</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AccountOutlineIcon />
            </div>
            <Field
              name="email"
              component="input"
              type="text"
              placeholder="Name"
              onKeyUp={this.formChangeHandler}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="password"
              component="input"
              type={this.state.showPassword ? "text" : "password"}
              placeholder="Password"
              onKeyUp={this.formChangeHandler}
            />
            <button
              className={`form__form-group-button${
                this.state.showPassword ? " active" : ""
              }`}
              onClick={(e) => this.showPassword(e)}
            >
              <EyeIcon />
            </button>
          </div>

          <div className="form__form-group">
            <span className="form__form-group-label colorWhite">
              <div className="account__forgot-password">
                <Link to="/forgot-password">Forgot a password?</Link>
              </div>
            </span>
          </div>
        </div>
        <div className="account__btns">
          <button
            className="btn btn-primary account__btn"
            onClick={this.submit}
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }
}

// <Link className="btn btn-outline-primary account__btn" to="/register">Create
//   Account
// </Link>

export default reduxForm({
  form: "log_in_form", // a unique identifier for this form
})(LogInForm);
